import './signUp.css';
 
import Form from '../../../components/forms/form';
import BackgroundImg from '../../../components/backgroundImg/backgroundImg';
import SignUpBackground from '../../../assets/sectionBackgrounds/signUpBackground/signUpBackground';
import IndividualPlans from '../../../assets/icons/individualPlans/individualPlans';
import EnterprisePlan from '../../../assets/icons/enterprisePlan/enterprisePlan';

import ToolFlipCards from '../../../components/toolFlipCards/toolFlipCards';

export default function signUp() {
    return(
        <div className="sign-up">
            <div className="sign-up-container">
                <div className="sign-up-left">
                    <BackgroundImg background={<SignUpBackground/>} customClass='background-sign-up-cloud' />
                    <Form 
                        submitType={'handleSignUp'}
                        formTag={'handleContactSubmit'} 
                        titleTag={'Create you account!'}
                        nameTag={true}
                        emailTag={true}
                        passwordTag={true}
                        confirmPassordTag={true}
                        />
                </div>
                <div className="sign-up-right">
                    <div className="flip-card-sign-up-container">
                        <ToolFlipCards flipQuantity={false} cardSize={false} signUpClass='flip-card-sign-up-container'
                            iconOne={<IndividualPlans/>} iconTwo={<EnterprisePlan/>}
                            titleOne='Individual Plans' titleTwo='Enterprise Plan'
                            barBool={true} barWidth={'80%'} barCenter={'auto'} barColor={'var(--text-color)'}
                            subTitleOne={'Simple, affordable expense tracking for individuals & small teams'} subTitleTwo={'Scalable finance control for growing organizations'}
                            textContentTopOne={'Essential features to capture, categorize, and report expenses with minimal setup.'} textContentTopTwo={'Advanced admin controls, permissions, and integrations to manage multi-department spending at scale.'}
                            bulletPointsOne={[
                                "Up to 3 users",
                                "Unlimited expense entries",
                                "Basic reporting (CSV export)",
                                "Receipt Capture",
                                "Email Support"
                            ]} 
                            bulletPointsTwo={[
                                "Unlimited users & profiles",
                                "Role-based permissions & approval",
                                "Advanced reporting & scheduled exports",
                                "Single sign-on (SSO) & audit logs",
                                "Priority support & onboarding",
                                "Dedicated account manager",
                                "Custom integrations"
                            ]}
                            textContentBottomOne={'Best for freelancers, solo entrepreneurs, and micro-businesses.'} 
                            textContentBottomTwo={'Perfect for mid-size to large companies, finance teams, and organizations requiring compliance and scale.'}
                            />
                        </div>
                </div>
            </div>
        </div>
    )
}